// Used by DropDownSelect2 and its reimplementation (ReactTreeSelect).

class DropDownBook
{
    id: number;
    name: string;
    categoryIds: Array<number>;
    // same as below without accents – if a link to a description page should
    // be presented
    linkingAbbreviation: string;
    sourceAbbreviation: string;
    sourcePartAbbreviation: string;
    // React
    selected: boolean;
    // DOM/jQuery (legacy)
    checkboxes: Array<HTMLInputElement>;
}

class DropDownCategory
{
    id: number;
    name: string;
    parentCategoryId: number;
    subcategoryIds: Array<number>;
    bookIds: Array<number>;
    externalId: string;
    // React
    selected: boolean;
    isOpen: boolean;
    // DOM/jQuery (legacy)
    checkBox: HTMLInputElement;
    moreSpan: HTMLSpanElement;
    childsDiv: JQuery<HTMLElement>;
}

export { DropDownBook, DropDownCategory };
